<div class="standart-page">
  <div class="standart-page-header">
    <span class="standart-page-title">Group Enrollment</span>
    <div class="d-flex">
      <a
        href="javascript:void(0);"
        (click)="createIndenpendantGroupEnrollment()"
        class="add-group-btn mr-3"
      >
        <i class="fas fa-plus fz-16 mr-2"></i>
        <span> Add Group Enrollment </span>
      </a>
      <a
        href="javascript:void(0);"
        class="standart-link-action"
        (click)="toggleFiltersPane()"
      >
        <i class="fas fa-filter"></i>
      </a>
    </div>
  </div>

  <div [(ngbCollapse)]="isFiltersExpanded">
    <div class="bg-gray p-3" [class.disabled]="isReadOnly">
      <filters
        [filterItems]="groupEnrollmentFilters"
        [filterValues]="filterValues ?? {}"
        [areas]="filterAreas"
        (applyFilterClick)="onApplyFilter($event)"
      ></filters>
    </div>
  </div>

  <div class="flex-container overflow-hidden">
    <div
      class="standart-table-wrapper"
      infiniteScroll
      (scrolled)="onScroll()"
      [scrollWindow]="false"
    >
      <ng-container *ngIf="groupEnrollmentsFiltred; else loading">
        <table
          class="standart-table"
          *ngIf="groupEnrollmentsFiltred.length; else empty"
        >
          <thead
            class="standart-table-header"
            sortable
            [directions]="sortDirections"
            (sort)="onSort($event)"
          >
            <tr>
              <th class="expand-cell"></th>
              <th sortBy="id">Group id</th>
              <th sortBy="providerGroup.name">Group Name</th>
              <th sortBy="npi">npi</th>
              <th sortBy="taxId">Tax ID</th>
              <th sortBy="payer.name">Payer Name</th>
              <th sortBy="enrollmentType">Type</th>
              <th sortBy="payerId">Payer ID</th>
              <th sortBy="processorId">Processor ID</th>
              <th sortBy="ediId">Routing ID</th>
              <th sortBy="enrollmentStatus" class="text-center">Status</th>
              <th sortBy="dateSetup">Created Date</th>
              <th sortBy="agreementApprovedDate">Approved Date</th>
              <th sortBy="followUpDate">Follow Up Date</th>
              <th class="actions-cell"></th>
            </tr>
          </thead>
          <tbody>
            <ng-container
              *ngFor="let groupEnrollment of groupEnrollmentsFiltred"
            >
              <tr>
                <td class="expand-cell">
                  <a
                    href="javascript:void(0);"
                    class="standart-link-action"
                    *ngIf="
                      groupEnrollment.subItems &&
                      groupEnrollment.subItems.length > 0
                    "
                    (click)="
                      groupEnrollment.isExpanded = !groupEnrollment.isExpanded
                    "
                    [class.expanded]="groupEnrollment.isExpanded"
                    [attr.aria-expanded]="!groupEnrollment.isExpanded"
                  >
                    <i class="fas fa-chevron-down"></i>
                  </a>
                </td>
                <td>{{ groupEnrollment.id || 'N/A' }}</td>
                <td>{{ groupEnrollment.providerGroup?.name || 'N/A' }}</td>
                <td>{{ groupEnrollment.npi || 'N/A' }}</td>
                <td>{{ groupEnrollment.taxId || 'N/A' }}</td>
                <td>{{ groupEnrollment.payer?.name || 'N/A' }}</td>
                <td>{{ groupEnrollment.enrollmentType || 'N/A' }}</td>
                <td>{{ groupEnrollment.payerId || 'N/A' }}</td>
                <td>{{ groupEnrollment.processorId || 'N/A' }}</td>
                <td>{{ groupEnrollment.ediId || 'N/A' }}</td>
                <td>
                  <div class="input-wrap select">
                    <select
                      class="input"
                      [disabled]="isReadOnly"
                      [(ngModel)]="groupEnrollment.enrollmentStatus"
                      (change)="onGroupEnrollmentStatusChanges(groupEnrollment)"
                    >
                      <option
                        *ngFor="
                          let groupEnrollmentStatus of groupEnrollmentStatuses
                        "
                        [value]="groupEnrollmentStatus"
                      >
                        {{ this.string_of_enum(groupEnrollmentStatus) }}
                      </option>
                    </select>
                  </div>
                </td>
                <td>
                  {{
                    (groupEnrollment.dateSetup | date: 'MM/dd/yyyy') || 'N/A'
                  }}
                </td>
                <td>
                  {{
                    (groupEnrollment.agreementApprovedDate
                      | date: 'MM/dd/yyyy') || 'N/A'
                  }}
                </td>
                <td>
                  {{
                    (groupEnrollment.followUpDate | date: 'MM/dd/yyyy') || 'N/A'
                  }}
                </td>
                <td class="actions-cell">
                  <div class="d-flex">
                    <div ngbDropdown container="body" class="ml-auto">
                      <a
                        href="javascript: void(0)"
                        [class.disabled]="isReadOnly"
                        class="standart-link-action"
                        ngbDropdownToggle
                      >
                        <i class="fas fa-chevron-circle-down"></i>
                      </a>
                      <div class="padding-top" ngbDropdownMenu>
                        <div class="dropdown-menu-inside">
                          <button
                            ngbDropdownItem
                            (click)="createGroupEnrollment(groupEnrollment)"
                          >
                            Add Group Enrollment
                          </button>
                          <button
                            ngbDropdownItem
                            (click)="openViewModifyEnrollment(groupEnrollment)"
                          >
                            View Modify Enrollments
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>

              <ng-container *ngFor="let innerGroup of groupEnrollment.subItems">
                <tr
                  [(ngbCollapse)]="groupEnrollment.isExpanded"
                  class="bg-gray"
                >
                  <td class="expand-cell"></td>
                  <td>{{ innerGroup.id || 'N/A' }}</td>
                  <td>{{ innerGroup.providerGroup?.name || 'N/A' }}</td>
                  <td>{{ innerGroup.npi || 'N/A' }}</td>
                  <td>{{ innerGroup.taxId || 'N/A' }}</td>
                  <td>{{ innerGroup.payer?.name || 'N/A' }}</td>
                  <td>{{ innerGroup.enrollmentType || 'N/A' }}</td>
                  <td>{{ innerGroup.payerId || 'N/A' }}</td>
                  <td>{{ innerGroup.processorId || 'N/A' }}</td>
                  <td>{{ innerGroup.ediId || 'N/A' }}</td>
                  <td>
                    <div
                      class="input-wrap select"
                      [class.disabled]="isReadOnly"
                    >
                      <select
                        class="input"
                        [(ngModel)]="innerGroup.enrollmentStatus"
                        (change)="onGroupEnrollmentStatusChanges(innerGroup)"
                      >
                        <option
                          *ngFor="
                            let groupEnrollmentStatus of groupEnrollmentStatuses
                          "
                          [value]="groupEnrollmentStatus"
                        >
                          {{ this.string_of_enum(groupEnrollmentStatus) }}
                        </option>
                      </select>
                    </div>
                  </td>
                  <td>
                    {{ (innerGroup.dateSetup | date: 'MM/dd/yyyy') || 'N/A' }}
                  </td>
                  <td>
                    {{
                      (innerGroup.agreementApprovedDate | date: 'MM/dd/yyyy') ||
                        'N/A'
                    }}
                  </td>
                  <td>
                    {{
                      (innerGroup.followUpDate | date: 'MM/dd/yyyy') || 'N/A'
                    }}
                  </td>
                  <td class="actions-cell">
                    <div class="d-flex">
                      <div ngbDropdown container="body" class="ml-auto">
                        <a
                          href="javascript: void(0)"
                          class="standart-link-action"
                          [class.disabled]="isReadOnly"
                          ngbDropdownToggle
                        >
                          <i class="fas fa-chevron-circle-down"></i>
                        </a>
                        <div class="padding-top" ngbDropdownMenu>
                          <div class="dropdown-menu-inside">
                            <button
                              ngbDropdownItem
                              (click)="createGroupEnrollment(innerGroup)"
                            >
                              Add Group Enrollment
                            </button>
                            <button
                              ngbDropdownItem
                              (click)="openViewModifyEnrollment(innerGroup)"
                            >
                              View Modify Enrollments
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="moreRowsExists">
              <tr>
                <td colspan="17">
                  <div class="d-flex w-100 h-100">
                    <loader></loader>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #loading>
  <loader *ngIf="isLoading; else empty"></loader>
</ng-template>

<ng-template #accessDenied>
  <empty-state text="Access Denied"> </empty-state>
</ng-template>

<ng-template #empty>
  <empty-state
    title="{{
      isLoading === null ? 'No Group Enrollments Yet' : 'No results found'
    }}"
    text="Filter, Search, and Sort to find specific items."
  ></empty-state>
</ng-template>
